import { FC, useState } from 'react';
import { Box, Chip, TextField, Typography } from '@mui/material';
import { representationSchemeType } from 'services/constants/representationSchemeType';
import { TCreateReturnItemProps } from './types';
import { COLORS } from 'services/constants/colors';
import { EasChip } from 'ui/EasChip';

export const CreateReturnItem: FC<TCreateReturnItemProps> = ({
	createReturnItem,
	returnItemQuantity,
	discount,
	value,
	setValue,
}) => {
	// const [value, setValue] = useState(0);
	const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
		if (Number(event.target.value) > createReturnItem.remainingQty) {
			setValue(`${createReturnItem.remainingQty}`);
			return;
		}
		if (Number(event.target.value) < 0) {
			setValue('0');
			return;
		}
		setValue(event.target.value);
	};
	return (
		<Box
			sx={{
				display: 'flex',
				flexDirection: 'row',
				justifyContent: 'space-between',
				// alignItems: 'center',
				mb: 1,
				opacity: createReturnItem.previousDiscounts || !createReturnItem.remainingQty ? '.4' : '1',
				'&:hover': { backgroundColor: '#f5f5f5' },
			}}
		>
			<Box
				key={createReturnItem.id}
				sx={{
					display: 'flex',
					flexDirection: 'row',
					gap: 1,
					mr: 4,
				}}
			>
				{' '}
				<Typography
					variant="body2"
					sx={{
						fontWeight: 'bold',
					}}
					color="primary"
				>
					{representationSchemeType?.[
						createReturnItem.scheme as keyof typeof representationSchemeType
					] ?? createReturnItem.scheme}
				</Typography>
				<Typography variant="body2">
					<span style={{ fontWeight: 'bold' }}>{createReturnItem.idProvidedByEm} — </span>
					{createReturnItem.shortDescription}
				</Typography>
				{!!returnItemQuantity && (
					<EasChip label={`${String(returnItemQuantity)} returned`} bgcolor={COLORS.RETURNED} />
				)}
				{discount && <EasChip label={`-${discount.toFixed(1)} %`} bgcolor={COLORS.DISCOUNT} />}
			</Box>
			<Box sx={{ display: 'flex' }}>
				<Typography variant="body2" sx={{ mr: 1 }} color="primary">
					{createReturnItem.remainingQty} item{!(createReturnItem.remainingQty === 1) && 's'}{' '}
					remained
				</Typography>
				<TextField
					size="small"
					variant="outlined"
					type="number"
					sx={{
						width: '70px',

						'& input': {
							textAlign: 'center',
							height: '20px',
							padding: '2px 0',
						},
					}}
					disabled={createReturnItem.previousDiscounts || !createReturnItem.remainingQty}
					value={value}
					onChange={handleChange}
				/>
			</Box>
		</Box>
	);
};
